<template>
  <div class="inventarView">
    <div class="action-buttons">
        <div class="left-buttons mar-rt-10">
        </div>
        <div class="right-buttons">
          <button class="btn add mar-rt-10"  @click.prevent="addInitialStock" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/add.png">
            {{$t('gestiune.addInitialStock')}}
          </button>
        </div>
    </div>
    <div class="card mar-to-15">
      <div class="card-content">
        <div class="data-table">
          <el-table :data="tableData" v-loading="loading" :empty-text="$t('gestiune.noData')" element-loading-text="Se încarcă...">
            <el-table-column label="Data Document">
              <template slot-scope="scope">
                {{ formatDate(scope.row.date) }}
              </template>
            </el-table-column>
            <el-table-column prop="gestiune" label="Gestiune"></el-table-column>
            <el-table-column prop="number_of_products" label="Nr. Produse"></el-table-column>
            <el-table-column :label="$t('general.actions')" width="100">
              <template slot-scope="scope">
                <el-dropdown trigger="click" placement="bottom-end">
                  <!-- Trigger: săgeată jos cu border violet -->
                  <span class="arrow-box">
                    &#9662;
                  </span>
                  <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item @click.native="editInitialStock(scope.row)">
                     {{$t('general.see')}}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFile(scope.row, 'pdf')">
                      {{$t('invoice.download')}}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="downloadFile(scope.row, 'xls')">
                      {{$t('gestiune.downloadExcel')}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  export default {
    // components: {
    //   GeneralTopBar
    // },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      },
      gestiuneOptions: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        loadingTimeout: null,
        totalItems: 0,
        currentPage: 1,
        pageSize: 50,
        tableData: [],
        gestiuniList: []
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')

      this.fetchInitialStock()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.fetchInitialStock()
      },
      handlePageChange (page) {
        this.currentPage = page
        this.fetchInitialStock(this.currentPage, this.pageSize)
      },
      getGestiuneNameById (id) {
        const gest = this.gestiuneOptions.find(g => g._id === id || g.id === id)
        return gest ? gest.name : id
      },
      addInitialStock () {
        this.$router.push('/management/initialStock/add')
      },
      async fetchInitialStock () {
        if (!this.companyID) return
        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = setTimeout(() => {
          this.loading = true
        }, 100)

        try {
          const params = new URLSearchParams()
          params.append('externalCompanyId', this.companyID)

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/stoc-initial/list?${params.toString()}`)
          if (!response.ok) throw new Error('Failed to fetch stoc initial')

          const data = await response.json()

          // răspunsul este { documents: [...] }
          this.tableData = data.documents.map(doc => ({
            _id: doc.id,
            date: doc.date,
            gestiune: doc.gestiune,
            gestiune_id: doc.gestiune_id,
            number_of_products: doc.number_of_products
          }))

          this.totalItems = this.tableData.length
          this.currentPage = 1
          this.pageSize = this.tableData.length // nu avem paginare pe API
        } catch (error) {
          swal.fire({
            icon: 'error',
            title: 'Eroare!',
            text: `Request failed: ${error.message}`,
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching stoc initial:', error)
        } finally {
          clearTimeout(this.loadingTimeout)
          this.loading = false
        }
      },
      editInitialStock (row) {
        this.$router.push(`/management/initialStock/edit/${row._id}`)
      },
      async downloadFile (row, format) {
        const gestiuneId = row.gestiune_id
        const externalCompanyId = this.companyID

        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/stoc-initial/${gestiuneId}/${format}?externalCompanyId=${externalCompanyId}`

        const response = await fetch(url)
        if (!response.ok) throw new Error(response.statusText)

        const blob = await response.blob()
        const link = document.createElement('a')

        link.href = URL.createObjectURL(blob)
        link.download = `stoc-initial-${gestiuneId}.${format}`
        link.click()

        URL.revokeObjectURL(link.href)
      }
    }
  }
</script>

<style scoped>
  .el-pagination {
    text-align: center !important;
  }
  .inventarView .edit {
    margin: 0 !important;
    margin-left: 10px !important;
  }
  .inventarView .downl {
    background: green !important;
    max-width: fit-content !important;
  }
  .inventarView .action-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center; /* Aliniază butoanele pe axa verticală */
    margin-bottom: 15px;
  }

  .left-buttons {
    display: flex;
  }

  .left-buttons el-button {
    margin-right: 10px; /* Spațiere între butoane */
  }

  .right-button {
    margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
  }
</style>
<style>
  .inventarView .el-table .cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .inventarView .el-table .cell .alignRight {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end !important;
  }
  .btn-success {
    width: auto !important;
    height: auto !important;
    margin-right: 20px !important;
  }
  .arrow-box {
    display: inline-block;
    font-size: 18px; /* mărimea săgeții */
    padding: 4px 6px;
    border: 1px solid #674BD2 !important; /* border violet */
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
    user-select: none;
    transition: background-color 0.2s, border-color 0.2s, color 0.2s;
    color: #674BD2; /* culoarea săgeții */
  }

  .arrow-box:hover {
    background-color: #674BD2 !important;
    border-color: #674BD2 !important;
    color: #fff !important; /* săgeata albă la hover */
  }

  /* Dropdown menu */
  .custom-dropdown-menu {
    min-width: 180px;
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/InitialStock/ManagementInitialStock.vue